import { fromFetch } from 'rxjs/fetch';

import { csvHeaders } from '../../../models/csv-headers';
import { selectBlob } from '../../../utils/select-blob';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Exports Vehicles
 * @returns A CSV file containing the exported Vehicles
 */
export function getVehiclesExport(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).vehiclesExportUrl, {
        method: 'GET',
        headers: {
          ...csvHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectBlob());
}
